import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

import { SearchResultType } from "@common/plants.enums";

import { BasicSearchCriteria } from "@models/BasicSearchCriteria";
import { Plant } from "@models/Plant";
import { TopLevelSearchResult } from "@models/TopLevelSearchResult";

import { FetchService } from "@services/fetch.service";
import { SearchService } from "@services/search.service";

import { AppConfig } from "../app.config";
import { Utilities } from "../utilities";

@Component({
  selector: "global-search",
  imports: [FormsModule],
  templateUrl: "global-search.component.html",
  styleUrls: ["global-search.component.scss"]
})
export class GlobalSearchComponent implements OnInit {
  @Output() searchTextChanged = new EventEmitter();

  showError = false;
  searchOptions: string[] = ["Scientific Name", "Common Name", "Symbol", "Family"];
  public selectedSearchOption: string;
  searchText = "";
  results: Plant[] = [];

  elementId = `${Date.now()}-${Utilities.getSecureRandomInt(0, 1000)}`;
  featureFlags: { [key: string]: boolean } = {};

  constructor(
    private appConfig: AppConfig,
    private fetchService: FetchService,
    private searchService: SearchService,
    private router: Router
  ) {
    this.featureFlags = this.appConfig.getFeatureFlags();
  }

  ngOnInit(): void {
    this.selectedSearchOption = this.searchOptions[0];

    if (
      this.searchService.searchCriteria &&
      this.searchService.searchCriteria.TaxonSearchCriteria
    ) {
      this.searchText = this.searchService.searchCriteria.TaxonSearchCriteria.Text;
    }
  }

  checkErrorMessage(): void {
    if (this.searchText.trim().length > 0) this.showError = false;
  }

  onkeyup(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      this.performSearch();
    } else {
      this.checkErrorMessage();
    }
  }

  performSearch(): void {
    // reset results
    this.results = [];

    if (this.searchText.trim().length == 0) {
      this.showError = true;
      return;
    }

    const searchCriteria = new BasicSearchCriteria(
      this.searchText.trim(),
      this.selectedSearchOption,
      "sortSciName",
      -1,
      null,
      null
    );
    this.searchService.searchCriteria = searchCriteria;

    this.searchService.updateSearchStatus(true);

    this.fetchService
      .fetchPlantsSearchResults(
        {
          ...this.searchService.searchCriteria,
          Type: SearchResultType.Basic
        },
        1
      )
      .then(this.displayResults.bind(this))
      .catch(this.displayResults.bind(this));
  }

  displayResults(result: TopLevelSearchResult): void {
    this.router
      .navigate(["/basic-search-results"], {
        queryParams: { resultId: result.ResultId }
      })
      .then(() => {
        this.searchService.updateSearchStatus(false);

        this.searchService.result = result;

        if (!this.searchService.criteriaHistory.has(result.ResultId))
          this.searchService.criteriaHistory.set(
            result.ResultId,
            this.searchService.searchCriteria
          );

        if (!this.searchService.searchTypeHistory.has(result.ResultId))
          this.searchService.searchTypeHistory.set(result.ResultId, this.searchService.searchType);

        if (
          this.searchService.resultHistory.filter((r) => r.ResultId == result.ResultId).length == 0
        )
          this.searchService.resultHistory.push(result);
      });
  }
}
